import React, { useState, useEffect} from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

const Home = () => {
  const [result, setResult] = useState("");
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let isMounted = true; // ✅ 컴포넌트가 언마운트되었는지 체크

    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (isMounted) setUser(user);
    };

    checkUser();

    // ✅ onAuthStateChange 구독 및 클린업 처리
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      if (isMounted) setUser(session?.user ?? null);
    });

    return () => {
      isMounted = false; // ✅ 언마운트 시 API 호출 막기
      subscription?.unsubscribe(); // ✅ 구독 해제
    };
  }, []); // ✅ useEffect가 한 번만 실행되도록 설정

  const fetchData = async ()=>{
    try{
      const response = await fetch( process.env.REACT_APP_WORKERS_URL+ "/api/hello");
      const data = await response.text();
      setResult(data);
    }catch(error){
      console.error("API 호출 중 오류 발생", error);
      setResult("API error");
    }
  }

  // ✅ 로그아웃 함수 추가
  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error("로그아웃 실패:", error.message);
      return;
    }
    navigate("/login"); // 로그아웃 후 로그인 페이지로 이동
  };

  // ✅ 탈퇴 요청 함수
  const handleDeleteAccount = async () => {
    if (!user) return;

    const confirmDelete = window.confirm("정말 탈퇴하시겠습니까? 계정 삭제 후 복구할 수 없습니다.");
    if (!confirmDelete) return;

    try {
      const response = await fetch(process.env.REACT_APP_WORKERS_URL+ "/api/deleteuser", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.id }),
      });

      const data = await response.json();
      if (data.success) {
        alert(user.email+"계정이 삭제되었습니다.~!");
        await supabase.auth.signOut();
        setUser(null);

        setTimeout(() => {
          navigate("/login");
        }, 100);
      } else {
        alert("탈퇴 실패: " + data.message);
      }
    } catch (error) {
      console.error("탈퇴 중 오류 발생:", error);
      alert("탈퇴 처리 중 오류가 발생했습니다.");
    }
  };
  
  return (
    <Container>
      <Typography variant="h4" mt={5}>
        엄빠어디가 테스트중 
      </Typography>
      <Box>{user ? user.email : ""}</Box>
      <Box sx={{mt:2,color:"primary.main"}}>{result}</Box>
        { user ? (
          <Box sx={{display:"flex", gap:2, mt:1, mb:1}}>
              <Button variant="contained" color="primary" onClick={()=>navigate("/main")}>MAIN</Button>
              <Button variant="contained" color="primary" onClick={handleLogout}>LOGOUT</Button>
              <Button variant="contained" color="normal" onClick={handleDeleteAccount}>탈퇴요청</Button>
          </Box>
        ) : (
          <Button variant="contained" color="primary" onClick={() => navigate("/login")}>LOGIN</Button> 
        )}
        <Button variant="contained" color="primary" onClick={fetchData} sx={{ml:5}}>
          API 호출
        </Button>
    </Container>
  );
};

export default Home;
